// Generated by `npm run levels:manifest`. Do not edit by hand.
import type { RawLevel } from "./parse";
import level001 from "./data/001.json";
import level002 from "./data/002.json";
import level003 from "./data/003.json";
import level004 from "./data/004.json";
import level005 from "./data/005.json";
import level006 from "./data/006.json";
import level007 from "./data/007.json";
import level008 from "./data/008.json";
import level009 from "./data/009.json";
import level010 from "./data/010.json";
import level020 from "./data/020.json";
import level040 from "./data/040.json";
import level060 from "./data/060.json";
import level080 from "./data/080.json";

/** Every level JSON in the bundle, in play order. */
export const LEVEL_FILES: RawLevel[] = [
  level001 as RawLevel,
  level002 as RawLevel,
  level003 as RawLevel,
  level004 as RawLevel,
  level005 as RawLevel,
  level006 as RawLevel,
  level007 as RawLevel,
  level008 as RawLevel,
  level009 as RawLevel,
  level010 as RawLevel,
  level020 as RawLevel,
  level040 as RawLevel,
  level060 as RawLevel,
  level080 as RawLevel,
];
